<template>
  <StepTwoDialog
    openBtnName="更换"
    ref="dialog"
    :stepTitles="stepTitles"
    :activeStep="activeStep"
    @before-next="handleBeforeNext"
    @before-close="handleBeforeClose"
    @closed="handleDialogClose"
     >
    <DataForm
      :rules="rules"
      ref="accountForm"
      :model="accountForm"
      label-width="100px"
      class="demo-ruleForm"
      :hide-required-asterisk="true" >
      <template v-if="activeStep === 0">
        <el-form-item label="验证方式">
          <el-row>
          <el-col>
            <el-input v-model="account" :disabled="true"></el-input>
          </el-col>
          </el-row>
          </el-form-item>
        <el-form-item label="验证码" prop="verificationCode">
          <el-row>
          <el-col :span="15">
            <el-input maxlength="4" :rule="rules.verificationCode" v-model.trim="accountForm.verificationCode" :placeholder="verificationCodePlaceholder"></el-input>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <el-button style="width:100%" plain :disabled="oldPhoneCode.disabled" @click="handleSendCode(oldPhoneCode)">{{oldPhoneCode.msg}}</el-button>
          </el-col>
          </el-row>
        </el-form-item>
      </template>
      <template v-else>
        <FormString
          v-model="accountForm.newAccount"
          v-noSpace
          prop="newAccount"
          :label="type === 'phone' ? '新手机号' : '新邮箱'"
          :placeholder="newAccountPlaceholder"/>
        <el-form-item label="验证码" prop="newVerificationCode">
          <el-row>
          <el-col :span="15">
            <el-input v-noSpace v-model.trim="accountForm.newVerificationCode" :placeholder="verificationCodePlaceholder"></el-input>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <el-button style="width:100%" plain :disabled="newPhoneCode.disabled" @click="handleSendNewCode(newPhoneCode)">{{newPhoneCode.msg}}</el-button>
          </el-col>
          </el-row>
        </el-form-item>
      </template>
    </DataForm>
  </StepTwoDialog>
</template>

<script>
import StepTwoDialog from './StepTwoDialog'
import { genInteractionCodeMethods } from './loginAccountUtil'
export default {
  components: {
    StepTwoDialog
  },
  props: ['type', 'account'],
  data() {
    return {
      activeStep: 0,
      accountForm: {
        verificationCode: undefined,
        newAccount: undefined,
        newVerificationCode: undefined
      },
      oldPhoneCode: this.getPhoenCode(),
      newPhoneCode: this.getPhoenCode(),
      rules: {
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '长度为4个字符', trigger: 'blur' }
        ],
        newAccount: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { validator: this.validatorPhoneOrEmail, trigger: 'blur' }
        ],
        newVerificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '长度为4个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    stepTitles() {
      return this.type === 'phone' ? ['安全验证', '绑定新手机号'] : ['安全验证', '绑定新邮箱']
    },
    verificationCodePlaceholder() {
      return this.type === 'phone' ? ' 请输入短信验证码' : '请输入邮件验证码'
    },
    newAccountPlaceholder() {
      return this.type === 'phone' ? '请输入新手机号码' : '请输入新邮箱'
    }
  },
  methods: {
    validatorPhoneOrEmail(rule, value, callback) {
      let phoneError = !/^1(3|4|5|7|8)\d{9}$/.test(value)
      let emailError = !/^([A-z0-9_-]+)@([A-z0-9_-]+)+(\.([A-z0-9_-]+))+$/.test(value)
      if (!phoneError || !emailError) {
        if (this.type === 'phone') {
          this.$service.checkPhone({ phone: this.$encrypt(value) }).then(data => {
            if (data.isError) {
              callback(new Error('该手机号已存在,请重新输入'))
            } else {
              callback()
            }
          })
        } else {
          callback()
        }
      } else {
        const type = this.type
        if (type !== 'phone') {
          callback(new Error('请输入正确的邮箱格式'))
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    },
    // 发送验证码
    handleSendCode(codeObj) {
      const user = this.$service.state.user || {}
      const type = this.type
      const account = type === 'phone' ? this.$encrypt(user.phone) : this.$encrypt(user.email)
      genInteractionCodeMethods(codeObj, () => {
        this.$service.sendCode({
          phone: type === 'phone' ? account : undefined,
          email: type !== 'phone' ? account : undefined
        })
      })
    },
    handleSendNewCode(codeObj) {
      const $ref = this.$refs.accountForm.$refs.form
      $ref.validateField('newAccount', (err) => {
        if (err !== '') {
          return
        }
        const account = this.$encrypt(this.accountForm.newAccount)
        const type = this.type
        genInteractionCodeMethods(codeObj, () => {
          this.$service.sendCode({
            phone: type === 'phone' ? account : undefined,
            email: type !== 'phone' ? account : undefined
          })
        })
      })
    },
    // 下一步
    handleBeforeNext() {
      const $ref = this.$refs.accountForm.$refs.form
      $ref.validateField('verificationCode', (err) => {
        if (err !== '') {
          return
        }
        const accountForm = this.accountForm
        const user = this.$service.state.user || {}
        const type = this.type
        const account = type === 'phone' ? user.phone : user.email
        this.$service.checkSmsCode({
          emailOrPhone: this.$encrypt(account),
          code: accountForm.verificationCode
        }).then(() => {
          this.activeStep++
        })
      })
    },
    // 完成
    handleBeforeClose() {
      const $ref = this.$refs.accountForm.$refs.form
      $ref.validate((valid) => {
        if (!valid) {
          return
        }
        const accountForm = this.accountForm
        // 检查验证码
        this.$service.checkSmsCode({
          emailOrPhone: this.$encrypt(accountForm.newAccount),
          code: accountForm.newVerificationCode
        }).then(() => {
          const user = this.$service.state.user || {}
          const type = this.type
          const account = type === 'phone' ? user.phone : user.email
          const updateInfo = {
            phoneOrEmail: type,
            oldData: this.$encrypt(account),
            oldCode: accountForm.verificationCode,
            newData: this.$encrypt(accountForm.newAccount),
            newCode: accountForm.newVerificationCode
          }
          // 修改信息
          this.$service.updatePhoneOrEmail(updateInfo, '修改成功').then(() => {
            this.$refs.dialog.isVisableDialog = false
            setTimeout(() => {
              const text = this.type === 'phone' ? '手机号已更换，将返回登录界面重新登录' : '邮箱地址已更换，将返回登录界面重新登录'
              this.$alert(text, '', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$service.logout()
                  this.$router.push({ name: 'login' })
                }
              })
            }, 500)
          })
        })
      })
    },
    getPhoenCode() {
      return {
        codeCount: 60,
        msg: '获取验证码',
        timer: null,
        disabled: false
      }
    },
    handleDialogClose() {
      this.activeStep = 0
      this.oldPhoneCode = this.getPhoenCode()
      this.newPhoneCode = this.getPhoenCode()
      this.$refs.accountForm.$refs.form.resetFields()
    }

  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
>>>.el-dialog__body
  padding 0
.demo-ruleForm
  max-width 500px
.demo-ruleForm >>>.el-form-item
  margin-bottom 15px
</style>
